<template>
    <!-- 使用说明 -->
    <section class="container">
        <Header></Header>
        <div class="wrapper">
            <div class="locationM text-left">
                <Breadcrumb>
                    <img class="img" src="../assets/location.png" alt="">
                    当前位置：
                    <BreadcrumbItem to="/">首页</BreadcrumbItem>
                    <BreadcrumbItem>操作指南</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="innerM">
                <div class="title">
                    使用说明
                </div>
                <div class="inner-wrapper" v-html="content">

                </div>
            </div>
        </div>
        <Footer></Footer>
    </section>
</template>

<script>
    import Header from './components/Header'
    import Footer from './components/Footer'
    import { data } from 'jquery';
    export default {
        name: "Lecture",
        data() {
            return {
                content: '',
            }
        },
        mounted() {
            this.getInstance();
            this.setTab();
        },
        watch: {
            '$route': {
                handler(newRoute, oldRoute) {
                    if (!oldRoute || newRoute.query.subjectCode !== oldRoute.query.subjectCode) {
                        this.getInstance();
                    }
                },
                deep: true,
                immediate: true
            },
        },
        methods: {
            getInstance() {
                var that = this;
                this.$http({
                    url: that.webhost + 'guide/getContent/2?subjectId=' + this.$route.query.subjectCode,
                    method: 'GET',
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        that.content = data.data;
                    }
                })
            }
        },
        components: {
            Header,
            Footer
        }
    }
</script>

<style scoped>
    .wrapper {
        width: 1200px;
        min-width: 1200px;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 90px;
        font-family: "PingFang SC";
    }

    .title {
        text-align: left;
        font-size: 25px;
        line-height: 72px;
        color: #000;
        border-bottom: solid 2px #ccc;
    }

    .locationM {
        height: 50px;
        line-height: 50px;
    }

    .locationM .ivu-breadcrumb {
        font-size: 15px;
        color: #000;
    }

    .locationM img {
        width: 23px;
        height: 22px;
        margin-right: 5px;
        position: relative;
        top: 3px;
    }

    .inner-wrapper {
        padding: 20px 15px;
    }
</style>


// WEBPACK FOOTER //
// src/views/Lecture.vue